<template>
  <div class="ui-avatar ui-avatar--wrapper ui-avatar-noselect">
    <div class="avatar" :style="[avatarStyle]">
      <!-- text -->
      <span class="ui-avatar--text" v-if="showText" :style="[textStyle]">{{ text }}</span>
      <!-- icon -->
      <icon v-if="showIcon" :style="[textStyle]" :icon="icon"></icon>
      <!-- status indicator -->
      <div class="ui-avatar--status" v-if="showStatus" :style="[statusStyle]">
        <div :style="[indicatorStyle]"></div>
      </div>
    </div>
    <!-- label -->
    <div class="ui-avatar--label" v-if="label" :style="[labelStyle]">{{label}}</div>
  </div>
  
</template>

<style scoped>
.ui-avatar--wrapper {
  position: relative;
  text-align: center;
}

.ui-avatar--text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.ui-avatar--label {
  padding: 10px;
  color: rgba(0, 0, 0, 0.54);
}

.ui-avatar--status {
  position: relative;
  transform: rotate(45deg);
}

.ui-avatar-noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome and Opera */
}
</style>

<script>
import Icon from '@/core/components/Icon'

const defaultAvatarSize = 100

export default {
  name: 'UiAvatar',
  components: {
    Icon
  },
  props: {
    name: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    icon: {
      type: String
    },
    value: {
      type: String
    },
    backgroundColor: {
      type: String,
      default: '#F0F0F0'
    },
    font: {
      type: String,
      default: 'sans-serif'
    },
    fontSize: {
      type: Number,
      default: 32
    },
    scaleFont: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#979797'
    },
    size: {
      type: Number,
      default: 80
    },
    src: {
      type: String
    },
    rounded: {
      type: Boolean,
      default: true
    },
    radius: {
      type: Number,
      default: 0
    },
    borderSize: {
      type: Number,
      default: 0
    },
    borderColor: {
      type: String,
      default: 'white'
    },
    showStatus: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    showText() {
      return !this.src && !this.icon
    },

    showIcon() {
      return !this.src && !this.value
    },

    background() {
      return this.backgroundColor
    },

    fontColor() {
      return this.color
    },

    isImage() {
      return Boolean(this.src)
    },

    avatarStyle() {
      const style = {
        position: 'relative',
        width: `${this.size}px`,
        height: `${this.size}px`,
        minWidth: `${this.size}px`,
        minHeight: `${this.size}px`,
        borderRadius: this.rounded ? '50%' : this.radius + 'px',
        border: `${this.borderSize}px solid ${this.borderColor}`
      }

      const imgBackgroundAndFontStyle = {
        background: `transparent url(${this
          .src}) no-repeat scroll 0% 0% / ${this.size}px ${this
          .size}px content-box border-box`
      }

      const initialBackgroundAndFontStyle = {
        backgroundColor: this.background,
        // font: Math.floor(this.size / 2.5) + `px/100px ${this.font}`,
        color: this.fontColor
      }

      const backgroundAndFontStyle = this.isImage
        ? imgBackgroundAndFontStyle
        : initialBackgroundAndFontStyle

      Object.assign(style, backgroundAndFontStyle)

      return style
    },

    textStyle() {
      const ratio = this.size / defaultAvatarSize
      const style = {
        color: this.fontColor,
        fontSize: this.scaleFont
          ? Math.round(this.fontSize * ratio) + 'px'
          : this.fontSize + 'px'
      }
      return style
    },

    // Math.floor(this.borderSize * 0.5) + `px solid ${this.borderColor}`
    statusStyle() {
      const style = {
        position: 'absolute',
        top: Math.round(this.borderSize * 0.5) + 'px',
        width: `${this.size}px`,
        height: `${this.size}px`,
        minWidth: `${this.size}px`,
        minHeight: `${this.size}px`,
        borderRadius: '50%'
      }
      return style
    },

    indicatorStyle() {
      const ratio = this.size / defaultAvatarSize
      const defaultSize = 16
      const defaultBorderSize = 3

      const style = {
        position: 'absolute',
        top: '0',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: Math.round(defaultSize * ratio) + 'px',
        height: Math.round(defaultSize * ratio) + 'px',
        background: '#ff8200',
        borderRadius: '50%',
        border:
          Math.max(1, Math.round(defaultBorderSize * ratio)) + 'px solid white'
      }
      return style
    },

    labelStyle() {
      const style = {
        color: this.fontColor
      }
      return style
    },

    text() {
      const value = this.value || this.initial(this.name)
      return value
    }
  },

  methods: {
    initial(name) {
      let parts = name.split(/[ -]/)
      let value = ''

      for (var i = 0; i < parts.length; i++) {
        value += parts[i].charAt(0)
      }

      if (value.length > 3 && value.search(/[A-Z]/) !== -1) {
        value = value.replace(/[a-z]+/g, '')
      }

      value = value.substr(0, 3).toUpperCase()

      return value
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/core/components/Avatar.vue